module.exports = __webpack_public_path__ + "img/c1.ad41047b.webp";